import React, { Suspense, lazy, useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import withRouter from "../hooks/withRouter"
import { Socialicons } from "../components/socialicons";
import { CSSTransition, TransitionGroup } from "react-transition-group";

const Home = lazy(() => import("../pages/home").then((module) => ({ default: module.Home })));
const Portfolio = lazy(() => import("../pages/portfolio").then((module) => ({ default: module.Portfolio })));
const ContactUs = lazy(() => import("../pages/contact"));
const Profile = lazy(() => import("../pages/about").then((module) => ({ default: module.About })));
const PublicationDetail = lazy(() => import("../pages/publication").then((module) => ({ default: module.PublicationDetail })));
const FypDetail = lazy(() => import("../pages/projectdetail/FypDetail").then((module) => ({ default: module.FypDetail })));
const PllDetail = lazy(() => import("../pages/projectdetail/PllDetail").then((module) => ({ default: module.PllDetail })));
const GenixEduDetail = lazy(() => import("../pages/projectdetail/GenixEduDetail").then((module) => ({ default: module.GenixEduDetail })));
const LedFlashDetail = lazy(() => import("../pages/projectdetail/LedFlashDetail").then((module) => ({ default: module.LedFlashDetail })));
const EcgDetail = lazy(() => import("../pages/projectdetail/EcgDetail").then((module) => ({ default: module.EcgDetail })));
const LpsDetail = lazy(() => import("../pages/projectdetail/LpsDetail").then((module) => ({ default: module.LpsDetail })));
const WaterLevelDetail = lazy(() => import("../pages/projectdetail/WaterLevelDetail").then((module) => ({ default: module.WaterLevelDetail })));
const NotFound = lazy(() => import("../pages/notfound").then((module) => ({ default: module.NotFound })));

const prefetchRoutes = () => {
  import("../pages/portfolio");
  import("../pages/about");
  import("../pages/contact");
};

const withLoader = (Component) => (
  <Suspense fallback={<div className="route-loader">Loading...</div>}>
    <Component />
  </Suspense>
);

const AnimatedRoutes = withRouter(({ location }) => (
  <TransitionGroup>
    <CSSTransition
      key={location.key}
      timeout={{
        enter: 400,
        exit: 400,
      }}
      classNames="page"
      unmountOnExit
    >
      <Routes location={location}>
        <Route path="/" element={withLoader(Home)} />
        <Route path="/profile" element={withLoader(Profile)} />
        <Route path="/about" element={<Navigate to="/profile" replace />} />
        <Route path="/work-showcase" element={withLoader(Portfolio)} />
        <Route path="/portfolio" element={<Navigate to="/work-showcase" replace />} />
        <Route path="/publications/:slug" element={withLoader(PublicationDetail)} />
        <Route path="/projects/fyp-speed-lpr" element={withLoader(FypDetail)} />
        <Route path="/projects/pll-ihp-sg13g2" element={withLoader(PllDetail)} />
        <Route path="/projects/genixedu" element={withLoader(GenixEduDetail)} />
        <Route path="/projects/led-flash" element={withLoader(LedFlashDetail)} />
        <Route path="/projects/ecg-heart-monitor" element={withLoader(EcgDetail)} />
        <Route path="/projects/linear-power-supply" element={withLoader(LpsDetail)} />
        <Route path="/projects/water-level-detector" element={withLoader(WaterLevelDetail)} />
        <Route path="/contact" element={withLoader(ContactUs)} />
        <Route path="*" element={withLoader(NotFound)} />
      </Routes>
    </CSSTransition>
  </TransitionGroup>
));

function AppRoutes() {
  useEffect(() => {
    if ("requestIdleCallback" in window) {
      const idleId = window.requestIdleCallback(prefetchRoutes, { timeout: 1800 });
      return () => window.cancelIdleCallback(idleId);
    }

    const timeoutId = window.setTimeout(prefetchRoutes, 1200);
    return () => window.clearTimeout(timeoutId);
  }, []);

  return (
    <div className="s_c">
      <AnimatedRoutes />
      <Socialicons />
    </div>
  );
}

export default AppRoutes;
